import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris.js'
import { GetCruiseRequest } from '../../../bewotec/openapi/index.js'
import { handleError } from '../../../general/errorHandling.js'
import { appHelper, mapAgencyForRequest } from '../../../store/app/helper'
import { useCabinStore, useCruiseStore, useDetailsStore, usePriceStore, useUserStore } from '../../../store/index.js'
import { cruiseHelper } from './helper.js'
import { IDetailCruise, IDetailRoute, IDetailShip } from './interfaces.js'

export const fetchCruise = async (cruiseId: string, priceModel: IbePriceModelCode) => {
  const cruiseStore = useCruiseStore()
  const detailsStore = useDetailsStore()
  const cabinStore = useCabinStore()
  const priceStore = usePriceStore()

  const bewotecCruise = await detailsCruiseHelper.fetchBewotecCruise(cruiseId, priceModel)

  if (!bewotecCruise) return

  const cruise: IDetailCruise = cruiseHelper.initCruise(bewotecCruise)
  const ship: IDetailShip = cruiseHelper.initShip(bewotecCruise.ship!)
  const route: IDetailRoute = cruiseHelper.initRoute(bewotecCruise)

  cruiseStore.cruise = cruise
  cruiseStore.ship = ship
  cruiseStore.route = route
  cabinStore.categories = cruiseHelper.initCategories(bewotecCruise, ship.id)
  cabinStore.decks = cruiseHelper.initDecks(bewotecCruise.ship!)
  detailsStore.mandatoryFlightForPriceModel = !!bewotecCruise.priceModel?.mandatoryFlight
  priceStore.cheapestFlightPrices = cruiseHelper.initCheapestFlightPrices(bewotecCruise)
  priceStore.extras = cruiseHelper.initExtras(bewotecCruise)
}

export const resetCruise = () => {
  const cruiseStore = useCruiseStore()

  cruiseStore.cruise = null
  cruiseStore.ship = null
  cruiseStore.route = null
  cruiseStore.isCruiseLoading = false
}

const fetchBewotecCruise = async (cruiseId: string, priceModel: IbePriceModelCode) => {
  const userStore = useUserStore()
  const cruiseStore = useCruiseStore()
  const detailsStore = useDetailsStore()

  cruiseStore.isCruiseLoading = true
  const paxConfig = detailsStore.paxConfig!
  let bewotecCruise = null

  try {
    const getCruiseRequest: GetCruiseRequest = {
      cruiseId,
      agencyId: mapAgencyForRequest(userStore.agencyId),
      priceModelCode: priceModel,
      adults: paxConfig.adults,
      juveniles: paxConfig.juveniles,
      children: paxConfig.children,
      babies: paxConfig.babies,
      xTrackingIdentifier: cruiseStore.requestId,
    }

    const cruiseResponse = await appHelper.bewotecMicroServiceApi().getCruiseRaw(getCruiseRequest)
    bewotecCruise = await cruiseResponse.value()

    if (cruiseResponse.raw.headers.get('x-tracking-identifier') !== cruiseStore.requestId) {
      // return if wrong cruise is loaded
      // prevents overriding of correct cruise
      return
    }

    return bewotecCruise
  } catch (error) {
    cruiseStore.resetCruise()
    handleError({ error, origin: 'fetchBewotecCruise' })
  } finally {
    cruiseStore.isCruiseLoading = false
  }
}

export default {
  fetchCruise,
  resetCruise,
}

// ---------- export for testing purposes only ----------

export const detailsCruiseHelper = {
  fetchBewotecCruise,
}
